import axios from 'axios';
import env from '@/env';

const baseURL = env.api.baseUrl.tokenBaseUrl;

const instance = axios.create({
  baseURL,
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
  },
});

export default instance;
